import { gql } from '@apollo/client';

export const fetchCampaignsQuery = gql`
  query getResourceCampaigns(
    $campaignFilterInfo: CampaignFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    campaigns(
      campaignFilterInfo: $campaignFilterInfo
      pagination: $pagination
      sort: $sort
      search: $search
    ) {
      results {
        id
        name
        createdBy
        updatedAt
      }
    }
  }
`;

export const fetchListsQuery = gql`
  query getLists($filterInfo: ListFilterInfoInput, $search: String, $sort: Sort) {
    lists(
      filterInfo: $filterInfo
      pagination: { limit: 25, offset: 0 }
      search: $search
      sort: $sort
    ) {
      results {
        id
        name
        listType
        creatorUserId
        updatedAt
      }
    }
  }
`;

export const fetchMessageTypes = gql`
  query getWorkflowMessageTypes {
    messageTypes {
      id
      name
      updatedAt
      messageChannel {
        name
      }
    }
  }
`;
